import React, { useCallback, useEffect, useRef, useState } from 'react';

// import {
//   Grid, 
// } from "@mui/material";

import { 
  Character,
  CharacterFeature,
  CharacterItem,
  CharacterSpell,
  CharacterSubclass,
  PseudoItem,
  Subclass,
  SummonOption2,
} from "@dndModels";
import { ModelBase } from "@models";

import DandDAPI from "@utilities/smart_api";
// import DataUtilities from '../../../utilities/common_utilities';
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

import CharacterListOptionsInput from "@dndComponents/character/misc/CharacterListOptionsInput";
import LoadingBox from "@components/input/LoadingBox";

interface Props {
  character: Character;
  obj: CharacterFeature;
  onChange: (changed: CharacterFeature) => void;
}

const api = DandDAPI.getInstance();
// const common_util = DataUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterSubclassInput({
  character,
  obj,
  onChange,
}: Props) {
  const fos = obj.feature_options as CharacterSubclass[];
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [use_subclasses, setUseSubclasses] = useState<Subclass[]>([]);
  const [selected, setSelected] = useState(fos.filter(o => o.source_id !== "").map(o => o.source_id));
  const [changing, setChanging] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    setReloading(true);
  }, [setReloading]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  const load = useCallback(() => {
    setFetched(true);
    // debugger;
    const subclasses = data_util.subclasses;
    let use_list = subclasses; 
    if (!character.c_options.allow_monster_feature_sources) {
      use_list = use_list.filter(o => !o.monster);
    }
    console.log(use_list);
    const char_class = character.spirit.classes.find(o => 
      o.true_id === obj.source_true_id);
    if (char_class) {
      use_list = use_list.filter(o => 
        (o.game_class_id === char_class.source_id ||
          char_class.variant_ids.includes(o.game_class_id)));
      use_list = use_list.filter(o => !character.c_options.blocked.includes(o._id));
      // use_list = use_list.sort((a,b) => {return a.name.localeCompare(b.name)});
      // filtered = api.filter("subclass", filtered, filter) as Subclass[];
    }
    // console.log(use_list);
    setUseSubclasses(use_list);
  }, [character, obj]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      load();
      character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
    }
  }, [character, fetched, setFetched, mounted, recalculated, load]);

  const change = useCallback(async () => {
    const new_obj = obj;
    const new_fos = new_obj.feature_options as CharacterSubclass[];
    const removed = new_fos.filter(o => !selected.includes(o.source_id));
    const added = selected.filter(o => new_fos.filter(o2 => o2.source_id === o).length === 0);
    if (removed.length > 0) {
      for (const char_subclass of removed) {
        if (char_subclass.source) {
          // console.log(char_subclass);
          for (const char_item of character.inventory.items) {
            // console.log(char_item);
            char_item.char_feature_bases = char_item.char_feature_bases.filter(o => 
              o.ancestries.filter(o2 => o2.true_id === char_subclass.true_id).length === 0);
            for (const scfs of char_item.sub_char_feature_sources) {
              scfs.char_feature_bases = scfs.char_feature_bases.filter(o => 
                o.ancestries.filter(o2 => o2.true_id === char_subclass.true_id).length === 0);
            }
          }
          char_util.removeCharFeatureBasesFor(character, char_subclass);
          char_subclass.char_feature_bases = [];
          char_subclass.source_id = "";
          char_subclass.source_name = "";
          char_subclass.source_type = "";
          char_subclass.source = null;
        }
      }
      onChange(new_obj);
    }
    if (added.length > 0) {
      for (const id of added) {
        // Get an empty char_subclass and set the selected_subclass to it
        const char_subclass = new_fos.find(o => o.source_id === "");
        const selected_subclass = data_util.subclasses.find(o => o._id === id);
        if (char_subclass && selected_subclass) {
          await api.loadObject(selected_subclass);
          await char_subclass.copy_source({ char: character, feature_source: selected_subclass, parent_cf: obj });
        }
      }
      onChange(new_obj);
    }
  }, [character, obj, onChange, selected]);

  useEffect(() => {
    if (changing) {
      setChanging(false);
      // debugger;
      change();
    }
  }, [changing, setChanging, change]);

  if (!fetched) {
    return (<LoadingBox />);
  } else {
    return (
      <>
        <CharacterListOptionsInput
          data_type="subclass"
          char={character}
          choose_max={fos.length} 
          use_objects={use_subclasses}
          selected={selected} 
          onChange={(changed: string[]) => {
            setSelected(changed);
            setChanging(true);
          }} 
          getDisabledReasons={(obj) => {
            if (obj instanceof Subclass) {
              // if (obj.name.includes("Ascendant Step")) {
              //   debugger;
              // }
              const reasons = char_util.fitLimits(character, obj.limitations, "subclass", obj._id);
              return reasons === "true" ? "" : reasons;
            }
            return "";
          }}
        />
      </>
    );
  }
}
